module.exports = __webpack_public_path__ + "static/10-625575b69dfc1c5544bd65d796f858fc.jpg";